import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { SPORT_NAME_PREMATCH } from '../../config/markets';
import { format } from 'date-fns';
import { Translate } from '../../localization';
import find from 'lodash.find';
import filter from 'lodash.filter';
import orderby from 'lodash.orderby';
import { connect } from 'react-redux';
import { clearPartialLocations } from '../../store/actions/todayActions';
import { lSportsConfig } from '../../config';
import { setTodaySportsWithDateRangeDesktop, getSportEventsDesktop, selectSportMobile, setDateFilter, getPrematchLocationsDesktop } from '../../store/actions/todayActions';
import { setHomeLeaguesActive } from '../../store/actions/home.actions';
import { useLocation } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel2';
import { withRouter } from 'react-router-dom';
import includes from 'lodash.includes';

const options = {
    // items: 10,
    navText: ['<div class=\'nav-btn prev-slide\'><i class="fas fa-chevron-left"></i></div>', '<div class=\'nav-btn next-slide\'><i class="fas fa-chevron-right"></i></div>'],
    nav: true,
    dots: false,
    // margin:15,
    responsive: {
        1200: {
            items: 4
        },
        1300: {
            items: 5
        },
        1400: {
            items: 6
        },
        1600: {
            items: 6
        },
        1900: {
            items: 6
        },
    }
};



const Filter = (props) => {
    let { sports, selectedSport, selectSportMobile, isDisable, mainEvents, dateFilter, type, isHomeLeagueActive, noEvents, sportCountObj } = props;
    const location = useLocation();
    const isFavActive = useMemo(() => location.pathname.split('/')[2] === 'favorites', [location]);
    const isLiveBets = useMemo(() => location.pathname.split('/')[2] === 'live-betting', [location]);
    const isHomeActive = useMemo(() => !location.pathname.split('/')[2], [location]);
    const isExtraOddsActive = useMemo(() => props.match.path == `${Translate.getLanguage()}/d/extra-market/:sportId/:fixtureId` ||
        props.match.path == `/${Translate.getLanguage()}/d/live-bettingextra-market/:sportId/:fixtureId/:liveStreamAvailable`, [props.match]);

    const refElement = useRef();


    const [hoverId, setHoverId ] = useState();

    useEffect(() => {
        if(!selectedSport) {
            selectSportMobile(lSportsConfig.inplay.selectedSport);
        }
    }, [selectSportMobile, selectedSport]);
    const handleClick = (e, value) => {
        e.preventDefault();
        let sportId = props.selectedSport;
        if ((props.mainEvents.length !== 0 || props.noEvents) && !isFavActive) {
            props.setDateFilter(value);
            props.selectSportMobile(sportId);
            props.getSportEventsDesktop(sportId);
            props.setTodaySportsWithDateRangeDesktop();
        }
        else if (isFavActive) {
            props.setDateFilter(value);
        }
    };

    const handleChangeSport = (sportId) => {
        if (!isHomeLeagueActive && sportId === props.selectedSport) return null;
        if (isLiveBets && !props.inplayLoading) return props.selectSportMobile(sportId);
        if ((mainEvents.length !== 0 || noEvents || isHomeLeagueActive) && !isFavActive) {
            props.selectSportMobile(sportId);
            props.clearPartialLocations();
            props.getPrematchLocationsDesktop();
        }
        else if (isFavActive) {
            props.selectSportMobile(sportId);
        }
        props.setHomeLeaguesActive(false);
        // if (isExtraOddsActive){
        //     selectSportMobile(sportId);
        //     if (isExtraActiveLive) 
        //     props.history.push('/d/live-betting');
        //     else if(isExtraActivePre) 
        //     props.history.push('/d/sports');
        // }  
    };

    if(['tomorrow', 'today', 'prematch', 'seven_days_finished'].includes(type)) {
        
        const football = find(sports, (item) => item.sport_id === 1);
        if (football && sportCountObj && sportCountObj[1] > 0) {
            let remSportsArray = filter(sports, (item) => item.sport_id !== 1);
            remSportsArray = orderby(remSportsArray, [(sport) => sportCountObj[sport.sport_id] > 0], ['desc']);
            sports = [football, ...remSportsArray];
        }
        else if(football) {
            sports = orderby(sports, [(sport) => sportCountObj[sport.sport_id] > 0], ['desc']);
            let selectedSportCount;
            if(sportCountObj[selectedSport]){
                selectedSportCount = sportCountObj[selectedSport];
            }
        }
    }
    
    let dateList = [];
    // for (var i = 0; i < 7; i++) {
    //     let date = new Date();
    //     let day = date.setDate(date.getDate() + i);
    //     let dayFormat = format(day, 'yyyy-MM-dd');        
    //     let dayFormatToShow = format(day, 'dd/MM');

    //     let preDefinedDay = null;
    //     if (i===0) preDefinedDay = Translate.today;
    //     else if (i===1) preDefinedDay = Translate.tomorrow;
    //     else preDefinedDay = dayFormatToShow;

    //     dateList.push(
    //         <li key={i} className='date-filter__item pre-match-wrapper' onClick={(e) => handleClick(e, dayFormat)}>
    //             <a href className={`${!isHomeLeagueActive && dateFilter === dayFormat && 'active'}`}>{ preDefinedDay }</a>
    //         </li>,
    //     );
    // }
  return (
      <div className=" links-block w-100">
          { !isHomeActive && !isExtraOddsActive && <div id='sport-filter' className="game-block w-100">
              { <ul className="d-flex">
                  <OwlCarousel
                        ref={refElement}
                        id='owl-demo'
                        options={ options }
                        onWheel={(e) =>{ if(e.deltaY > 0) {
                            refElement.current.next();
                        } else {
                            refElement.current.prev();
                        }}}
                    >
                      { Object.values(sports).map(item => {
                      let sportId = item.sport_id;
                      let sportName = item.name;
                      let sportImage = item.icon_name;
                      let count;
                      if(['tomorrow', 'today', 'prematch', 'seven_days_finished'].includes(type) && sportCountObj) {
                        count = sportCountObj[sportId] ? sportCountObj[sportId] : 0;
                        }
                      const className = !isHomeLeagueActive && sportId == selectedSport ? 'active' : '';
                      return (
                        
                          <li className={ className } onMouseOver={() => setHoverId(sportId)} onMouseLeave={() => setHoverId('')} onClick={ !isDisable ? (e) => handleChangeSport(sportId) : null } key={sportId}>
                              <a href >
                                  {/* <div className='sports__counter'> 20 </div> */}
                                  {/* { sportId == selectedSport || sportId == hoverId ? <img alt="stream-icon" className="nav-ico-dark" src={`/images/sports/${item.icon_name}-desktop.svg`}></img>
                                   :  */}
                                   {/* <img alt="stream" className="nav-ico-light" src={`/images/sports/${item.icon_name}-desktop.svg`}></img> 
                                  <span>{sportName}</span>
                                  <span id={`sport-filter-${ sportId }`} /> */}
                                    <div className={`new-sports-card ${sportImage}`}>
                                        <div className='sports-caption-wrap'>
                                            <div className='new-sports-name'>
                                                <h4>{sportName}</h4>
                                            </div>
                                            <div className='sports-details'>
                                                {count > -1 && 
                                                    <div className='events-count'>
                                                        {Translate.totalEvents} :{count}
                                                    </div>
                                                }
                                                {/* <div className='events-cta'>
                                                    <a href='javascript:void(0)' className='btn btn-primary'>open</a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                              </a>
                          </li>
                          
                      );
                  })}
                  </OwlCarousel>
              </ul>
            }
          </div>
        }
          <div className="sort-links">
              <ul className="d-flex">
                  { !isLiveBets && dateList}
              </ul>
          </div>

      </div>
  );
};


const mapStateToProps = (state) => {
    return {
        dateFilter: state.today.dateFilter,
        selectedSport: state.today.selectedSport,
        mainEvents: state.today.mainEvents,
        noEvents: state.today.noEvents,
        language: state.general.language,
        isHomeLeagueActive: state.home.isHomeLeagueActive,
        inplayLoading: state.inplay.isLoading,	
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setDateFilter: (value) => dispatch(setDateFilter(value)),
        selectSportMobile: (sportId) => dispatch(selectSportMobile(sportId, true)),
        setTodaySportsWithDateRangeDesktop: () => dispatch(setTodaySportsWithDateRangeDesktop()),
        getSportEventsDesktop: (sportId) => dispatch(getSportEventsDesktop(sportId)),
        setHomeLeaguesActive: (value) => dispatch(setHomeLeaguesActive(value)),
        clearPartialLocations: () => dispatch(clearPartialLocations()),
        getPrematchLocationsDesktop: () => dispatch(getPrematchLocationsDesktop()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Filter));